import axios from 'axios';
import { toast } from 'react-toastify';
import {
  COLLECTIONS_UPDATE_QUERY_OF_COLLECTION_BEGIN,
  COLLECTIONS_UPDATE_QUERY_OF_COLLECTION_SUCCESS,
  COLLECTIONS_UPDATE_QUERY_OF_COLLECTION_FAILURE,
  COLLECTIONS_UPDATE_QUERY_OF_COLLECTION_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function updateQueryOfCollection(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_UPDATE_QUERY_OF_COLLECTION_BEGIN,
    });
    const { projectId, collectionUuid, filterUuid, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/finders/${collectionUuid}/collection/${filterUuid}`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: COLLECTIONS_UPDATE_QUERY_OF_COLLECTION_SUCCESS,
            data: res.data,
          });
          toast.success('Updated Successfully !');
          resolve(res);
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_UPDATE_QUERY_OF_COLLECTION_FAILURE,
            data: { error: err },
          });
          toast.error('Updation Failed !');
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateQueryOfCollectionError() {
  return {
    type: COLLECTIONS_UPDATE_QUERY_OF_COLLECTION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_UPDATE_QUERY_OF_COLLECTION_BEGIN:
      return {
        ...state,
        updateQueryOfCollectionPending: true,
        updateQueryOfCollectionError: null,
      };

    case COLLECTIONS_UPDATE_QUERY_OF_COLLECTION_SUCCESS:
      return {
        ...state,
        updateQueryOfCollectionPending: false,
        updateQueryOfCollectionError: null,
        selectedCollection: action.data,
      };

    case COLLECTIONS_UPDATE_QUERY_OF_COLLECTION_FAILURE:
      return {
        ...state,
        updateQueryOfCollectionPending: false,
        updateQueryOfCollectionError: action.data.error,
      };

    case COLLECTIONS_UPDATE_QUERY_OF_COLLECTION_DISMISS_ERROR:
      return {
        ...state,
        updateQueryOfCollectionError: null,
      };

    default:
      return state;
  }
}
